import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=034a307b&"
import script from "./EditDialog.vue?vue&type=script&lang=js&"
export * from "./EditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034a307b')) {
      api.createRecord('034a307b', component.options)
    } else {
      api.reload('034a307b', component.options)
    }
    module.hot.accept("./EditDialog.vue?vue&type=template&id=034a307b&", function () {
      api.rerender('034a307b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/stream/EditDialog.vue"
export default component.exports